<template>
  <div class="auth-wrapper auth-v2">
    
    <b-row class="auth-inner m-0">
      <!-- Brand logo-->
      <b-link class="brand-logo">
        <vuexy-logo />
        <h2 class="brand-text text-primary ml-1">
          AddCo
        </h2>
      </b-link>
      

      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col
        lg="8"
        class="d-none d-lg-flex align-items-center p-5 position-relative"
      >
        <div class="login-bg"></div>
        <!-- <div class="w-100 d-lg-flex align-items-center justify-content-center px-5 position-relative"></div> -->
        <h3 class="slogan">{{ $t('message.slogan') }}</h3>
      </b-col>
      <!-- /Left Text-->

      <!-- Login-->
      <b-col
        lg="4"
        class="d-flex align-items-center auth-bg px-2 p-lg-5"
        style="background-color: #02162E;"
      >
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto"
        >
          <b-card-title
            class="mb-1 font-weight-bold text-white"
            title-tag="h2"
          >
            {{ $t('message.Welcome to AddCo') }}
          </b-card-title>

          <add-to-home-screen :responsive="false" class="mt-2 mb-2"/>

          <b-card-text class="mb-2 text-white">
            {{ $t('message.signInMsg') }}
          </b-card-text>

          <!-- <b-alert
            variant="primary"
            show
          >
            <feather-icon
              v-b-tooltip.hover.left="'This is just for ACL demo purpose'"
              icon="HelpCircleIcon"
              size="18"
              class="position-absolute"
              style="top: 10; right: 10;"
            />
          </b-alert> -->

          <!-- form -->
          <validation-observer
            ref="loginForm"
            #default="{invalid}"
          >
            <b-form
              class="auth-login-form mt-2"
              @submit.prevent="loginWithCognito"
            >
              <!-- email -->
              <b-form-group
                label-for="login-email"
              >
                <label style="margin-bottom: 0.5rem;" class="text-white" for="login-password">{{ $t('message.email_label') }}</label>
                <validation-provider
                  #default="{ errors }"
                  name="Email"
                  vid="email"
                  rules="required|email"
                >
                  <b-form-input
                    id="login-email"
                    v-model="userEmail"
                    :state="errors.length > 0 ? false:null"
                    name="login-email"
                    :placeholder="$t('message.email_example')"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- forgot password -->
              <b-form-group>
                <div class="d-flex justify-content-between">
                  <label class="text-white" for="login-password">{{ $t('message.password') }}</label>
                  <b-link style="margin-bottom: 0.5rem; color: #62A1ED" :to="{name:'auth-forgot-password'}">
                    <small >{{ $t('message.forgotPassword') }}</small>
                  </b-link>
                </div>
                <validation-provider
                  #default="{ errors }"
                  name="Password"
                  vid="password"
                  rules="required"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                  >
                    <b-form-input
                      id="login-password"
                      v-model="password"
                      :state="errors.length > 0 ? false:null"
                      class="form-control-merge"
                      :type="passwordFieldType"
                      name="login-password"
                      :placeholder="$t('message.password')"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- checkbox -->
              <!-- <b-form-group>
                <b-form-checkbox
                  id="remember-me"
                  v-model="status"
                  name="checkbox-1"
                >
                  Remember Me
                </b-form-checkbox>
              </b-form-group> -->

              <!-- submit buttons -->
              <b-button
                type="submit"
                variant="primary"
                block
                :disabled="invalid"
              >
                {{ $t('message.signIn') }}
              </b-button>
            </b-form>
          </validation-observer>

        <!--
          <b-card-text class="text-center mt-2">
            <span>New on our platform? </span>
            <b-link :to="{name:'auth-register'}">
              <span>&nbsp;Create an account</span>
            </b-link>
          </b-card-text>

          <!- - divider - ->
          <div class="divider my-2">
            <div class="divider-text">
              or
            </div>
          </div>

          <!- - social buttons - ->
          <div class="auth-footer-btn d-flex justify-content-center">
            <b-button
              variant="facebook"
              href="javascript:void(0)"
            >
              <feather-icon icon="FacebookIcon" />
            </b-button>
            <b-button
              variant="twitter"
              href="javascript:void(0)"
            >
              <feather-icon icon="TwitterIcon" />
            </b-button>
            <b-button
              variant="google"
              href="javascript:void(0)"
            >
              <feather-icon icon="MailIcon" />
            </b-button>
            <b-button
              variant="github"
              href="javascript:void(0)"
            >
              <feather-icon icon="GithubIcon" />
            </b-button>
          </div>
        -->

          <!-- Loading -->
          <loading
            v-if="isLoading"
            :active="true" 
            :is-full-page="false"
            color="#498ceb"
          />
        </b-col>
      </b-col>
    <!-- /Login-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import {  BRow, BCol, BLink, BFormGroup, BFormInput, BInputGroupAppend, BInputGroup, BFormCheckbox, BCardText, BCardTitle, BImg, BForm, BButton, BAlert, VBTooltip } from 'bootstrap-vue'
// import useJwt from '@/auth/jwt/useJwt'
import { required, email } from '@validations'
import store from '@/store/index'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import AddToHomeScreen from '@/views/habit/AddToHomeScreen.vue';
import i18n from '@/libs/i18n'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import useNotifications from '@/composables/useNotifications'
import { onMounted, ref, computed } from '@vue/composition-api'
import { useRouter } from '@core/utils/utils'
// import realmConnection from '@/views/habit/realm'
import { useCognito } from '@/views/habit/awsCognito'
import { useToast } from 'vue-toastification/composition'
import { getCurrentInstance } from '@vue/composition-api'
import { useLambda } from '@/views/habit/awsLambda'
import { oid } from '@/helpers/mongoHelpers'
import { mergePermissions } from '@/auth/utils'
import { defaultPassword } from '@/constants'

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    BAlert,
    VuexyLogo,
    ValidationProvider,
    ValidationObserver,
    AddToHomeScreen,
    Loading,
  },
  data() {
    return {
      status: '',
      sideImg: require('@/assets/images/pages/login-v2.svg'),

      // validation rules
      required,
      email,
    }
  },
  setup() {
    const { route, router } = useRouter()
    const { showSuccessMessage, showErrorMessage } = useNotifications()
    // const { getItem, getItemsWithAggregate } = realmConnection()
    const { getItem, getItemsAggregate } = useLambda()
    const { login: cognitoLogin, logout, isAuthenticated, getCurrentUser } = useCognito()
    const toast = useToast()
    const { proxy } = getCurrentInstance()

    const userEmail = ref('')
    const password = ref('')
    const passwordFieldType = ref('password')
    const loginForm = ref(null)
    const isLoading = ref(false)
    const defaultAbility = [{ action: 'manage', subject: 'all' }]

    const passwordToggleIcon = computed(() => {
      return passwordFieldType.value === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    })

    const togglePasswordVisibility = () => {
      passwordFieldType.value = passwordFieldType.value === 'password' ? 'text' : 'password'
    }

    /**
     * Validates user in MongoDB.
     * Returns the user document and related doc (if any), or throws a user-friendly error.
     */
    const validateUserInDB = async (email) => {
      const userDoc = await getItem({ collection: 'worker', query: { email, deleted: { $ne: true } } })

      if (!userDoc) {
        await logout()
        throw new Error('Usuario no encontrado. Contacte al administrador.')
      }

      return userDoc
    }

    /**
     * Stores user session data (cookies + localStorage) and redirects
     */
    const setSessionAndRedirect = async (userData, clientData, token, loginPassword) => {
      // Set session (localStorage + ability + store)
      localStorage.setItem('userData', JSON.stringify(userData))
      localStorage.setItem('clientData', JSON.stringify(clientData))
      localStorage.setItem('accessToken', token)
      proxy.$ability.update(defaultAbility)
      store.commit('userStore/updateUserData', userData)

      // Redirect to initial page or dashboard
      const { role, username } = userData

      // Check if password is the default one and redirect to change password
      const needsPasswordChange = loginPassword === defaultPassword
      // El link de respuesta individual de un control (mail al responsable) siempre tiene
      // prioridad, incluso por sobre el cambio de contraseña obligatorio: es un flujo puntual,
      // fuera del uso normal de la app, y perder esa referencia obligaría a rearmar el acceso.
      const isControlResponseLink = route.value.query.from?.startsWith('/habit/confirmation/respond/')
      const initialRoute = isControlResponseLink
        ? route.value.query.from
        : needsPasswordChange
          ? '/pages/account-setting'
          : (route.value.query.from || clientData.homePagePath || (role === 'employee' && '/organization/complaint/list') || '/habit/general/dashboard')

      router.replace(initialRoute)
        .then(() => {
          toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: needsPasswordChange ? i18n.t('message.passwordChangeRequired') : `${i18n.t('Welcome')} ${username || ''}`,
              icon: needsPasswordChange ? 'AlertCircleIcon' : 'CoffeeIcon',
              variant: needsPasswordChange ? 'warning' : 'success',
              text: needsPasswordChange
                ? i18n.t('message.shouldChangePassword')
                : `${i18n.t('Successful Login As')} ${i18n.t(`userRoles.${role}`)}. ${i18n.t('Start To Explore')}!`,
            },
          })
        })
        .catch((err) => {
          console.log(err);
        })
    }

    const loginWithCognito = async () => {
      try {
        const formValidated = await loginForm.value.validate()
        if (!formValidated) return

        isLoading.value = true

        // Try normal Cognito login
        let accessToken
        let cognitoUser

        try {
          const result = await cognitoLogin({ email: userEmail.value, password: password.value })
          accessToken = result.accessToken
          cognitoUser = getCurrentUser()
        } catch (cognitoError) {
          throw cognitoError
        }

        // Usuario existe en Cognito → validar en MongoDB
        if (!cognitoUser || !cognitoUser.email) {
          await logout()
          throw new Error('Error de autenticación. Intente nuevamente.')
        }

        const dbUser = await validateUserInDB(cognitoUser.email)

        // Get worker data
        const { privileges: role, name: username, _id: worker_id } = dbUser

        const pipeline = [
          { $match: { _id: oid(worker_id) } },
          { $lookup: { from: 'location', localField: 'locations', foreignField: '_id', pipeline: [ { $project: { location: 1 } } ], as: 'locationsData' } },
          { $lookup: { from: 'role', localField: 'roles', foreignField: '_id', pipeline: [ { $project: { name: 1 } } ], as: 'rolesData' } },
        ]

        const [items, permissionDoc, overrideDoc] = await Promise.all([
          getItemsAggregate({ collection: 'worker', pipeline }),
          getItem({ collection: 'permission_default', query: { privilege: role } }),
          getItem({ collection: 'worker_permission_override', query: { worker_id: oid(worker_id) } }),
        ])
        if (!items?.[0]) throw new Error('Item not found')

        const workerData = items[0]
        const clientId = workerData.client_id

        const userData = {
          fullName: username || '',
          username,
          email: userEmail.value,
          role,
          ability: defaultAbility,
          worker_id: worker_id ? { $oid: worker_id } : null,
          client: clientId ? { $oid: clientId } : null,
          locations: workerData.locationsData?.map(({ location, _id }) => ({ title: location, value: _id })) || [],
          isComplaintManager: workerData.isComplaintManager,
          appRole: workerData.rolesData?.length ? workerData.rolesData[0].name : '',
          // permission_default[role] fusionado con worker_permission_override[worker_id]
          // (si existe) — mergePermissions() decide acción por acción, ningún componente
          // necesita saber si un valor vino de uno u otro.
          permissions: mergePermissions(permissionDoc?.modules, overrideDoc?.modules),
        }

        // Get client data
        const clientData = await getItem({ collection: 'client', query: { _id: oid(clientId) } })
        if (!clientData) throw new Error('Client not found')

        if (clientData?.default_language) i18n.locale = clientData.default_language

        // Set session and redirect
        await setSessionAndRedirect(userData, clientData, accessToken, password.value)
      } catch (error) {
        console.error('Login error:', error)
        const errors = {
          email: [],
          password: ['Error de autenticación. Intente nuevamente.'],
        }
        loginForm.value.setErrors(errors)
        logout()
      } finally {
        isLoading.value = false
      }
    }

    // const login = () => {
    //   loginForm.value.validate().then(success => {
    //     if (success) {
    //       isLoading.value = true
    //       useJwt.login({
    //         email: userEmail.value,
    //         password: password.value,
    //       })
    //         .then(async () => {
    //           try {
    //             const {
    //               custom_data: {
    //                 role, ability, extras, username, worker_id = null, client_id = null, project = ''
    //               },
    //               deleted = false
    //             } = useJwt.realm.currentUser.customData
    //             const { id, accessToken, refreshToken } = useJwt.realm.currentUser
    //             if (deleted) {
    //               const errors = { email: ["Invalid Email"], password: ["Invalid Password"]}
    //               loginForm.value.setErrors(errors)
    //               useJwt.logout()
    //               isLoading.value = false
    //               return false;
    //             }
    //             useJwt.setToken(accessToken)
    //             useJwt.setRefreshToken(refreshToken)

    //             // Get worker data
    //             const workerId = worker_id?.$oid || ''

    //             const pipeline = [
    //               { $match: { _id: oid(workerId) } },
    //               { $lookup: { from: 'location', localField: 'locations', foreignField: '_id', pipeline: [ { $project: { location: 1 } } ], as: 'locationsData' } },
    //               { $lookup: { from: 'role', localField: 'roles', foreignField: '_id', pipeline: [ { $project: { name: 1 } } ], as: 'rolesData' } },
    //             ]

    //             const items = await getItemsWithAggregate({ collection: 'worker', pipeline })
    //             if (!items?.[0]) throw new Error('Item not found')

    //             const workerData = items[0]
    //             const clientId = workerData.client_id

    //             const userData = {
    //               id,
    //               fullName: username || '',
    //               username,
    //               avatar: require('@/assets/images/avatars/13-small.png'),
    //               email: userEmail.value,
    //               role,
    //               ability,
    //               extras,
    //               worker_id,
    //               project,
    //               client: clientId ? { $oid: clientId.toString() } : null,
    //               locations: workerData.locationsData?.map(({ location, _id }) => ({ title: location, value: _id.toString() })) || [],
    //               isComplaintManager: workerData.isComplaintManager,
    //               appRole: workerData.rolesData?.length ? workerData.rolesData[0].name : '',
    //             }

    //             localStorage.setItem('userData', JSON.stringify(userData))

    //             // Get client data
    //             const clientData = await getItem({ collection: 'client', query: { _id: clientId } })
    //             if (!clientData) throw new Error('Client not found')

    //             if (clientData?.default_language) i18n.locale = clientData.default_language
    //             localStorage.setItem('clientData', JSON.stringify(clientData))

    //             const initialRoute = route.value.query.from || clientData.homePagePath || (role === 'employee' && '/organization/complaint/list') || '/habit/general/dashboard'
                
    //             router.replace(initialRoute)
    //               .then(() => {
    //                 toast({
    //                   component: ToastificationContent,
    //                   position: 'top-right',
    //                   props: {
    //                     title: `${i18n.t('Welcome')} ${username || ''}`,
    //                     icon: 'CoffeeIcon',
    //                     variant: 'success',
    //                     text: `${i18n.t('Successful Login As')} ${i18n.t(`userRoles.${role}`)}. ${i18n.t('Start To Explore')}!`,
    //                   },
    //                 })
    //               })
    //               .catch((err) => {
    //                 console.log(err);
    //                 isLoading.value = false
    //               })

    //             proxy.$ability.update(ability || [])
    //             store.commit('app-ecommerce/UPDATE_CART_ITEMS_COUNT', extras?.eCommerceCartItemsCount || 0)
    //             store.commit('userStore/updateUserData', userData)
    //           }
    //           catch(e) {
    //             console.error(e)
    //             isLoading.value = false
    //           }
    //         })
    //         .catch(error => {
    //           console.log(error)
    //           const errors = {
    //             password: [], email: [],
    //           }
    //           if (error.errorCode === 'InvalidPassword') {
    //             errors.password = [error.error]
    //           }
    //           if (error.errorCode === 'InvalidEmail') {
    //             errors.email = [error.error]
    //           }
    //           loginForm.value.setErrors(errors)
    //           isLoading.value = false
    //         })
    //     }
    //   })
    // }

    onMounted(() => {
      // Set locale based on browser language
      const locale = window.navigator.language?.startsWith('es') ? 'es' : 'en'
      i18n.locale = locale
      localize(locale)

      if (route.value.query.session === "expired") {
        showErrorMessage(i18n.t('message.session_expired'))
      }
    })
    
    return {
      getItem,
      // getItemsWithAggregate,
      // ObjectId,
      logout,
      isAuthenticated,
      userEmail,
      password,
      // login,
      loginForm,
      isLoading,
      passwordToggleIcon,
      passwordFieldType,
      togglePasswordVisibility,
      loginWithCognito,
    }
  },
  computed: {
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/pages/login-v2-dark.svg')
        return this.sideImg
      }
      return this.sideImg
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
.login-bg {
  position: absolute;
  inset: 0;
  background: url('/login.png') center center / cover no-repeat;
}
.slogan {
  position: absolute;
  bottom: 5rem;
  left: 2rem;
  color: #498CEB
}
</style>